module.exports = __webpack_public_path__ + "static/media/34DSS1.a0f66641.jpg";